module.exports = __webpack_public_path__ + "img/information-icon.b3260ad8.svg";